
<template>
  <div>
    <svg width="100%" height="100%"  v-if="!reverse" viewBox="0 0 722 34" preserveAspectRatio="xMinYMin  meet">
        <defs>
            <linearGradient x1="46.0556782%" y1="50%" x2="98.2227856%" y2="50%" id="linearGradient-1">
                <stop stop-color="#070916" offset="0%"></stop>
                <stop stop-color="#1655B0" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
            <g transform="translate(-30.000000, -51.000000)" fill="url(#linearGradient-1)">
                <g  transform="translate(30.000000, 51.000000)">
                    <path d="M644,0 L624.27322,34.2734375 L0,34.2734375 L0,0 L644,0 Z M670.041016,0 L651.380322,34.2734375 L637.041016,34.2734375 L656.249157,0 L670.041016,0 Z M696.041016,0 L677.945798,34.2734375 L664.041016,34.2734375 L682.667092,0 L696.041016,0 Z M722.041016,0 L703.380322,34.2734375 L689.041016,34.2734375 L708.249157,0 L722.041016,0 Z"></path>
                </g>
            </g>
        </g>
    </svg>
    <svg width="100%" height="100%" v-if="reverse"   viewBox="0 0 722 34" preserveAspectRatio="xMinYMin  meet">
        <defs>
            <linearGradient x1="46.0556782%" y1="50%" x2="97.5201428%" y2="50%" id="linearGradient-1">
                <stop stop-color="#070916" offset="0%"></stop>
                <stop stop-color="#144FA4" offset="100%"></stop>
            </linearGradient>
        </defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g  transform="translate(-1198.000000, -50.000000)" fill="url(#linearGradient-1)">
                <g  transform="translate(1558.500000, 67.500000) scale(-1, 1) translate(-1558.500000, -67.500000) translate(1197.000000, 50.000000)">
                    <path  d="M644,0 L624.27322,34.2734375 L0,34.2734375 L0,0 L644,0 Z M670.041016,0 L651.380322,34.2734375 L637.041016,34.2734375 L656.249157,0 L670.041016,0 Z M696.041016,0 L677.945798,34.2734375 L664.041016,34.2734375 L682.667092,0 L696.041016,0 Z M722.041016,0 L703.380322,34.2734375 L689.041016,34.2734375 L708.249157,0 L722.041016,0 Z"></path>
                </g>
            </g>
        </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'DvDecoration8_vip',
  props: {  
    reverse: {
      type: Boolean,
      default: false
    }
  },
  data () {  
    return {     
     
    }
  },
  methods: {
 
  },
  mounted () {
  
  }
}
</script>

